import { Card } from '@dma/ui';
import type { ContactInfoContent } from '../../../content/company-info.content';
import './ContactInfo.css';

export interface ContactInfoProps {
  content: ContactInfoContent;
}

export function ContactInfo({ content }: ContactInfoProps) {
  return (
    <Card className="dma-contact-info">
      <p className="dma-contact-info__office-label">{content.officeLabel}</p>
      <dl className="dma-contact-info__list">
        <div className="dma-contact-info__row">
          <dt>آدرس</dt>
          <dd>{content.address}</dd>
        </div>
        <div className="dma-contact-info__row">
          <dt>تلفن و واتساپ</dt>
          <dd>
            <a href={`tel:${content.phone}`}>{content.phone}</a>
            {' · '}
            <a href={content.whatsappHref} target="_blank" rel="noreferrer">
              چت در واتساپ
            </a>
          </dd>
        </div>
        <div className="dma-contact-info__row">
          <dt>ایمیل</dt>
          <dd>
            <a href={`mailto:${content.email}`}>{content.email}</a>
          </dd>
        </div>
        <div className="dma-contact-info__row">
          <dt>ساعات کاری</dt>
          <dd>{content.workingHours}</dd>
        </div>
        <div className="dma-contact-info__row">
          <dt>شبکه‌های اجتماعی</dt>
          <dd className="dma-contact-info__social">
            {content.socialLinks.map((social) =>
              social.href ? (
                <a key={social.platform} href={social.href} target="_blank" rel="noreferrer">
                  {social.label}
                </a>
              ) : (
                <span key={social.platform} className="dma-contact-info__social-pending">
                  {social.label} (به‌زودی)
                </span>
              )
            )}
          </dd>
        </div>
      </dl>
    </Card>
  );
}
